import React, {
  forwardRef,
  ReactChild,
  ReactFragment,
  ReactPortal,
} from "react";

import { Label, Input } from "./style";
interface ICheckboxProps {
  className?: string;
  name?: string;
  value?: string;
  checked?: boolean;
  onChange?: () => void;
  children:
    | ReactChild
    | ReactFragment
    | ReactPortal
    | boolean
    | null
    | undefined;
}
const Checkbox = forwardRef<HTMLInputElement, ICheckboxProps>(
  ({ className, children, name, value, checked, onChange }, ref) => (
    <Label className={className}>
      <Input
        ref={ref}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      {children}
    </Label>
  )
);

export default Checkbox;
